export default "__VITE_ASSET__CRo4DZs3__"